<template>
  <div>
    <rkm-area no-margin-top title="Filtros" type="fieldset">
      <rkm-form ref="Form">

        <rkm-row>
          <rkm-col cols="4">
            <rkm-form-group
                  label-for="Competência *"
                  label="Competência *"
                  class="mb-0"
              >
                  <rkm-row>
                      <rkm-col cols="6">
                          <rkm-form-select
                              :validations="validations.competencia.ano"
                              :options="form.competencias.anos"
                              showDefaultOption
                              default-option-text="SELECIONE"
                              v-model="model.competencia.ano"
                              append="Anos"
                              name="Ano"
                          />
                      </rkm-col>

                      <rkm-col cols="6">
                          <rkm-form-select
                              :options="form.competencias.meses"
                              :validations="validations.competencia.mes"
                              showDefaultOption
                              default-option-text="SELECIONE"
                              v-model="model.competencia.mes"
                              append="Meses"
                              name="Mês"
                              text-field="descricao"
                              value-field="valor"
                          />
                      </rkm-col>
                  </rkm-row>
              </rkm-form-group>
          </rkm-col>

          <rkm-col cols="4">
            <rkm-form-select
              :options="form.unidades"
              v-model="model.unidade"
              showDefaultOption
              default-option-text="TODOS"
              label="Unidade"
              text-field="descricao"
              value-field="id"
            />
          </rkm-col>

          <rkm-col cols="4">
            <rkm-form-select
              :options="form.profissionais"
              v-model="model.profissional"
              show-default-option
              default-option-text="TODOS"
              label="Profissional"
              text-field="descricao"
              value-field="id"
            />
          </rkm-col>
        </rkm-row>

        <rkm-row>
          <rkm-col cols="4">
            <rkm-form-select
              :options="form.locaisAtendimento"
              v-model="model.localAtendimento"
              showDefaultOption
              default-option-text="TODOS"
              label="Local de atendimento"
              text-field="descricao"
              value-field="id"
            />
          </rkm-col>

          <rkm-col cols="1">
            <rkm-form-input
              v-model="model.prontuario"
              label="Prontuário"
            />
          </rkm-col>

          <rkm-col cols="3">
            <rkm-form-group
                  label-for="Idade"
                  label="Idade"
                  class="mb-0"
              >
                  <rkm-row>
                      <rkm-col cols="6">
                          <rkm-form-input
                              v-model="model.idadeMinima"
                              append="Min"
                              name="Min"
                              :min="0"
                              number
                          />
                      </rkm-col>

                      <rkm-col cols="6">
                          <rkm-form-input
                              v-model="model.idadeMaxima"
                              append="Max"
                              name="Max"
                              number
                          />
                      </rkm-col>
                  </rkm-row>
              </rkm-form-group>
          </rkm-col>

          <rkm-col cols="2">
            <rkm-form-select
              :options="form.sexos"
              v-model="model.sexo"
              showDefaultOption
              default-option-text="AMBOS"
              label="Sexo"
              text-field="descricao"
              value-field='id'
            />
          </rkm-col>

          <rkm-col cols="2">
            <rkm-form-select
              :options="form.hipertensos"
              v-model="model.hipertenso"
              showDefaultOption
              default-option-text="TODOS"
              label="Hipertenso"
              text-field="descricao"
              value-field='valor'
            />
          </rkm-col>
        </rkm-row>

        <rkm-row>
          <rkm-col cols="2">
            <rkm-form-select
              :options="form.condicoesAvaliadas"
              v-model="model.condicaoAvaliada"
              showDefaultOption
              default-option-text="TODOS"
              label="Condição avaliada"
              text-field="descricao"
              value-field='id'
            />
          </rkm-col>
          <rkm-col cols="2">
            <rkm-form-select
              :options="form.doencasTransmissiveis"
              v-model="model.doencaTransmissivel"
              showDefaultOption
              default-option-text="TODOS"
              label="Doença transmissível"
              text-field="descricao"
              value-field='id'
            />
          </rkm-col>
          <rkm-col cols="2">
            <rkm-form-select
              :options="form.rastreamentos"
              v-model="model.rastreamento"
              showDefaultOption
              default-option-text="TODOS"
              label="Rastreamento"
              text-field="descricao"
              value-field='id'
            />
          </rkm-col>

          <rkm-col cols="3">
            <rkm-form-input-autocomplete
                :searchFields="fields.autocomplete.ciap"
                :requestQueryStringParams="autocompleteRequestParams.ciap2"
                :repository="repositories.ciap"
                label="CIAP2"
                :text-field="c => `${c.codigo} - ${c.descricao}`"
                placeholder="Digite o código ou o nome do CIAP2"
                v-model="model.ciap2"
                uppercase
            >
              <template v-slot:itemLabel="{ item }">
                {{ item.codigo }} - {{ item.descricao }}
              </template>
            </rkm-form-input-autocomplete>
          </rkm-col>

          <rkm-col cols="3">
            <rkm-form-input-autocomplete
              :searchFields="fields.autocomplete.cid"
              :requestQueryStringParams="autocompleteRequestParams.cid"
              :repository="repositories.cid"
              label="CID10"
              v-model="model.cid"
              :text-field="c => `${formatCid(c.codigo)} - ${c.nome}`"
              placeholder="Digite o código ou o nome do CID"
              uppercase
            >
                <template v-slot:itemLabel="{ item }">
                    {{ formatCid(item.codigo) }} - {{ item.nome }}
                </template>
            </rkm-form-input-autocomplete>
          </rkm-col>
        </rkm-row>

        <rkm-row>
          <rkm-col cols="2">
            <rkm-form-select
              :options="form.gestantes"
              v-model="model.gestante"
              showDefaultOption
              default-option-text="TODOS"
              label="Gestante"
              text-field="descricao"
              value-field='valor'
              :disabled="model.sexo == enums.sexo.MASCULINO"
            />
          </rkm-col>

          <rkm-col cols="2">
            <rkm-form-select
              :options="form.diabeticos"
              v-model="model.diabetico"
              showDefaultOption
              default-option-text="TODOS"
              label="Diabético"
              text-field="descricao"
              value-field='valor'
            />
          </rkm-col>
          

          <rkm-col cols="2">
            <rkm-form-select
              :options="form.vacinas"
              showDefaultOption
              default-option-text="TODOS"
              v-model="model.vacina"
              label="Vacina em dia"
              text-field="descricao"
              value-field='valor'
            />
          </rkm-col>

          <rkm-col cols="3">
            <rkm-form-select
              :options="form.aleitamentosMaterno"
              v-model="model.aleitamentoMaterno"
              showDefaultOption
              default-option-text="TODOS"
              label="Aleitamento materno"
              text-field="descricao"
              value-field='id'
            />
          </rkm-col>
          <rkm-col>
            <rkm-button :label="false" color="primary" @click="search"
              >Buscar</rkm-button
            >
            <rkm-button :label="false"  @click="handleLimparClick">Limpar</rkm-button>
          </rkm-col>
        </rkm-row>
      </rkm-form>
    </rkm-area>

    <rkm-area
      title="Totais"
      type="fieldset"
      no-margin-top
      v-if="mostraAreaResultado"
    >
      <rkm-row>
        <rkm-col cols="3">
          Registro(s)
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.registros }} </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col cols="3">
          Unidade(s)
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.unidades }} </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col cols="3">
          Profissional(s)
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.profissionais }} </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col cols="3">
          Local(s) de atendimento
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.locaisAtendimento }} </strong>
          </rkm-alert>
        </rkm-col>
      </rkm-row>
    </rkm-area>

    <rkm-area no-margin-top title="Resultado" v-if="mostraAreaResultado">
      <template v-slot:trailing>
        <rkm-button
          :disabled="items.length === 0"
          @click="handleImprimirClick"
          color="info"
          small
          title="Imprimir"
        >
          <rkm-icon icon="print" />
        </rkm-button>

        <rkm-button
          :disabled="items.length === 0"
          @click="handleExportarClick"
          color="info"
          small
          title="Exportar"
        >
          <rkm-icon icon="file-export" />
        </rkm-button>
      </template>

      <rkm-table
          :fields="fields.table"
          :items="items"
      >
      </rkm-table>
    </rkm-area>

    

  </div>
</template>

  <script>
import { mapActions } from "vuex";
import { repository, error, data, object, stringCase, file, formats } from "@/mixins";

// Enums
import sexo from '@/enums/atencao-basica/sexo'
import mesesAno from '@/enums/geral/mesesAno'

export default {
  computed: {
    autocompleteRequestParams() {
      return {
        ciap2: {
            sexo_id: this.model.sexo,
            ciap_id: this.model.ciap2 ? this.model.ciap2.id : null,
        },
        cid: {
            sexo: this.model.sexo,
            cid_id: this.model.cid ? this.model.cid.id : null,
        },
      }
    },
    fields() {
      return {
        autocomplete: {
          cid: [
              { key: 'codigo', searchable: true },
              { key: 'nome', searchable: true },
          ],
          ciap: [
              { key: 'codigo', searchable: true },
              { key: 'descricao', searchable: true },
          ],
        },
        table: this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
      }

    },
    validations() {
      return {
        competencia: {
          ano: { required: true },
          mes: { required: true },
        }
      }
    },
  },
  created() {
    this.repositories = {
      relatorioEstatisticoAtendimento: this.getConectaSusRepository("atencaoBasica.relatorioEstatisticoAtendimento"),
      ciap: this.getConectaSusRepository('geral.ciap'),
      cid: this.getConectaSusRepository('sigtap.cid'),
      impressao: this.getConectaSusRepository("impressao.atencaoBasica"),
      exportacao: this.getConectaSusRepository("exportacao.atencaoBasica"),
    };
    this.load();
  },
  data() {
    return {
      indeterminate: true,
      model: {
        competencia: {
          ano: null,
          mes: null,
        }
      },
      form: {
        competencias: {
          anos: null,
          meses: null,
        },
      },
      items: [],
      selectedAll: true,
      selectedColumns: [],
      mostraAreaResultado: false,
      total: null,
      selectedCols: ["areas", "pacientesForaArea"],
      totalizadores: {
        registros: 0,
        unidades: 0,
        profissionais: 0,
        locaisAtendimento: 0,
      },
      todasMicroareasVisiveis: [],
      columns: [
        {
          key: "data",
          label: "Data",
          sortable: true,
          fixed: true,
        },
        {
          key: "unidade",
          label: "Unidade",
          sortable: true,
          fixed: true,
        },
        {
          key: "paciente",
          label: "Paciente",
          sortable: true,
          fixed: true,
        },
        {
          key: "prontuario",
          label: "Prontuario",
          sortable: true,
          fixed: true,
        },
        {
          key: "dataNascimento",
          label: "Data Nascimento",
          sortable: true,
          fixed: true,
        },
        {
          key: "idade",
          label: "Idade",
          sortable: true,
          fixed: true,
        },
        {
          key: "sexo",
          label: "Sexo",
          sortable: true,
          fixed: true,
        },
        {
          key: "profissional",
          label: "Profissional",
          sortable: true,
          fixed: true,
        },
        {
          key: "hipertenso",
          label: "Hipertenso",
          sortable: true,
          fixed: true,
        },
        {
          key: "diabetico",
          label: "Diabético",
          sortable: true,
          fixed: true,
        },
        {
          key: "gestante",
          label: "Gestante",
          sortable: true,
          fixed: true,
        },
        {
          key: "aleitamentoMaterno",
          label: "Aleitamento Materno",
          sortable: true,
          fixed: true,
        },
        {
          key: "localAtendimento",
          label: "Local Atendimento",
          sortable: true,
          fixed: true,
        },
        {
          key: "condicaoAvaliada",
          label: "Condição Avaliada",
          sortable: true,
          fixed: true,
        },
        {
          key: "vacina",
          label: "Vacina em Dia",
          sortable: true,
          fixed: true,
        },
      ],
      dataAtual: null,
      enums: { sexo, mesesAno },
    };
  },
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    load() {
      this.setLoading();
      this.repositories.relatorioEstatisticoAtendimento
        .index()
        .then(({ data }) => {
          this.form = Object.assign(data.form)
          this.model = Object.assign(data.model)
          this.dataAtual = data.dataAtual
          this.getAnosCompetencia();
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    request() {
        return this.clone(this.model)
    },
    getAnosCompetencia() {
      this.setLoading();
      const request = { listar: 'ano', ...this.request() }
      this.repositories.relatorioEstatisticoAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
          .then(({data}) => {
              this.form.competencias.anos = data;
          })
          .catch(this.handleError)
          .finally(() => {
              this.unsetLoading();
          })
    },
    getMesesCompetencia() {
      this.setLoading();
      const request = { listar: 'mes', ...this.request() }
      this.repositories.relatorioEstatisticoAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
          .then(({data}) => {
              const meses = data;
              this.form.competencias.meses = meses.map(mes => {
                return {
                  descricao: this.enums.mesesAno[mes],
                  valor: mes
                }
              })
          })
          .catch(this.handleError)
          .finally(() => {
              this.unsetLoading();
          })
    },
    getUnidades() {
      this.setLoading();
      const request = { listar: 'unidade', ...this.request() }
      this.repositories.relatorioEstatisticoAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
          .then(({data}) => {
              this.form.unidades = data;
          })
          .catch(this.handleError)
          .finally(() => {
              this.unsetLoading();
          })
    },
    getProfissionais() {
      this.setLoading();
      const request = { listar: 'profissional', ...this.request() }
      this.repositories.relatorioEstatisticoAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
          .then(({data}) => {
              this.form.profissionais = data;
          })
          .catch(this.handleError)
          .finally(() => {
              this.unsetLoading();
          })
    },
    getLocaisAtendimento() {
      this.setLoading();
      const request = { listar: 'localAtendimento', ...this.request() }
      this.repositories.relatorioEstatisticoAtendimento.list(this.camelObjectKeysToSnakeRecursive(request))
          .then(({data}) => {
              this.form.locaisAtendimento = data;
          })
          .catch(this.handleError)
          .finally(() => {
              this.unsetLoading();
          })
    },
    search() {
      if(!this.model.competencia.ano || !this.model.competencia.mes) {
        this.createNotification({
            type: 'alert',
            color: 'danger',
            title: 'Ação não permitida',
            message: 'É necessário informar o ano e o mês da competência.'
        })

        return;
      }

      const colunas = this.columns.map(item => {
          if (item.key === 'gestante') {
              return { ...item, fixed: this.model.sexo !== this.enums.sexo.MASCULINO };
          }
          return item;
      });

      this.columns = colunas;

      this.setLoading();
      const request = { 
        listar: 'localAtendimento', 
        ...this.request(),
        condicaoAvaliada: this.form.condicoesAvaliadas.find(item => item.id == this.model.condicaoAvaliada),
        doencaTransmissivel: this.form.doencasTransmissiveis.find(item => item.id == this.model.doencaTransmissivel),
        rastreamento: this.form.rastreamentos.find(item => item.id == this.model.rastreamento),
      }
      this.repositories.relatorioEstatisticoAtendimento
        .search(this.camelObjectKeysToSnakeRecursive(request))
        .then(({ data }) => {
          this.items = data.registros;
          this.totalizadores = data.totalizadores;
          this.mostraAreaResultado = true;

        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },

    handleLimparClick() {
        this.mostraAreaResultado = false;
        this.model.competencia.mes = null;
        this.model.competencia.ano = null;
        this.model.unidade = null;
        this.model.profissional = null;
        this.model.localAtendimento = null;
        this.model.prontuario = null;
        this.model.idadeMinima = null;
        this.model.idadeMaxima = null;
        this.model.sexo = null;
        this.model.hipertenso = null;
        this.model.gestante = null;
        this.model.diabetico = null;
        this.model.condicaoAvaliada = null;
        this.model.doencaTransmissivel = null;
        this.model.rastreamento = null;
        this.model.vacina = null;
        this.model.aleitamentoMaterno = null;
        this.model.ciap2 = null;
        this.model.cid = null;
    },

    handleImprimirClick() {
        this.setLoading()

        const request = {
            ...this.request(),
            condicaoAvaliada: this.form.condicoesAvaliadas.find(item => item.id == this.model.condicaoAvaliada),
            doencaTransmissivel: this.form.doencasTransmissiveis.find(item => item.id == this.model.doencaTransmissivel),
            rastreamento: this.form.rastreamentos.find(item => item.id == this.model.rastreamento),
            selectedColumns: this.fields.table.map(field => ({
                class: field.class,
                key: this.camelToSnake(field.key),
                label: field.label,
            })),
        }

        this.repositories.impressao.relatorioEstatisticoAtendimento(this.camelObjectKeysToSnakeRecursive(request))
            .then(({ data, headers }) => this.openFile(data, headers['content-type']))
            .finally(() => this.unsetLoading())
    },

    handleExportarClick() {
        this.setLoading()

        const request = {
            ...this.request(),
            condicaoAvaliada: this.form.condicoesAvaliadas.find(item => item.id == this.model.condicaoAvaliada),
            doencaTransmissivel: this.form.doencasTransmissiveis.find(item => item.id == this.model.doencaTransmissivel),
            rastreamento: this.form.rastreamentos.find(item => item.id == this.model.rastreamento),
            selectedColumns: this.fields.table.map(field => ({
                class: field.class,
                key: this.camelToSnake(field.key),
                label: field.label,
            })),
        }

        this.repositories.exportacao.relatorioEstatisticoAtendimento(this.camelObjectKeysToSnakeRecursive(request))
            .then(({ data, headers }) => this.openFile(data, headers['content-type']))
            .finally(() => this.unsetLoading())
    },
  
    prepareDataWithColumns() {
      const data = this.prepareData();
      const fields = this.fields.table.filter((item) => item.key !== undefined);
      data.selectedCols = fields.map((f) => {
        return {
          key: this.camelToSnake(f.key),
          label: f.label,
          class: f.class,
        };
      });

      return data;
    },
    prepareData() {
      const data = this.clone(this.model);
      return this.camelObjectKeysToSnakeRecursive(data);
    },
  },
  mixins: [repository, error, data, object, stringCase, file, formats],
  watch: {
    'model': {
      deep: true,
      handler() {
        this.mostraAreaResultado = false
      }
    },
    'model.competencia.ano': {
        deep: true,
        handler() {
          this.model.competencia.mes = null;
          this.getMesesCompetencia();
        },
    },
    'model.competencia.mes': {
        deep: true,
        handler(value) {
          if(value) {
            this.model.unidade = null;
            this.model.profissional = null;
            this.model.localAtendimento = null;
            this.getUnidades();
            this.getProfissionais();
            this.getLocaisAtendimento();
          }
        },
    },
    'model.unidade': {
        deep: true,
        handler(value) {
          if(!value  && this.model.competencia.mes) {
            this.getProfissionais();
            this.getLocaisAtendimento();
          }

          if(value && this.model.competencia.mes) {
            this.getProfissionais();
            this.getLocaisAtendimento();
          }
          this.model.profissional = null;
        },
    },
    'model.profissional': {
        deep: true,
        handler(value) {
          if(!value  && this.model.competencia.mes) {
            this.getLocaisAtendimento();
          }

          if(value && this.model.competencia.mes) {
            this.getLocaisAtendimento();
          }
          this.model.localAtendimento = null;
        },
    },
  },
};
</script>
